"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

exports.__esModule = true;
exports.navItemTheme = exports.secondaryNavItemTheme = exports.primaryNavItemTheme = exports.navigationTheme = exports.secondaryNavTheme = exports.primaryNavTheme = void 0;

var _styles = require("../styles");

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var primaryNavTheme = function primaryNavTheme(baseTheme) {
  return {
    PrimaryNav_backgroundColor: baseTheme.backgroundColor_themePrimary,
    PrimaryNav_backgroundColor_minimal: baseTheme.backgroundColor,
    PrimaryNav_gutter: baseTheme.space_inline_xs,
    PrimaryNav_paddingHorizontal: baseTheme.space_inline_xl,
    PrimaryNav_paddingVertical: baseTheme.space_stack_sm
  };
};

exports.primaryNavTheme = primaryNavTheme;

var secondaryNavTheme = function secondaryNavTheme(baseTheme) {
  return {
    SecondaryNav_backgroundColor_pills: baseTheme.backgroundColor,
    SecondaryNav_backgroundColor_tabs: baseTheme.color_gray_20,
    SecondaryNav_border: "1px solid " + baseTheme.color_gray_30,
    SecondaryNav_gutter: baseTheme.space_inline_xxs,
    SecondaryNav_paddingHorizontal: (0, _styles.pxToEm)(12),
    SecondaryNav_paddingVertical: baseTheme.space_stack_sm
  };
};

exports.secondaryNavTheme = secondaryNavTheme;

var navigationTheme = function navigationTheme(baseTheme) {
  return _objectSpread({}, primaryNavTheme(baseTheme), secondaryNavTheme(baseTheme), baseTheme);
};

exports.navigationTheme = navigationTheme;

var primaryNavItemTheme = function primaryNavItemTheme(baseTheme) {
  return {
    PrimaryNavItem_backgroundColor: 'transparent',
    PrimaryNavItem_backgroundColor_active: baseTheme.color_theme_80,
    PrimaryNavItem_backgroundColor_focus: 'transparent',
    PrimaryNavItem_backgroundColor_hover: baseTheme.color_theme_70,
    PrimaryNavItem_backgroundColor_selected: baseTheme.color_theme_80,
    PrimaryNavItem_backgroundColor_minimal: 'transparent',
    PrimaryNavItem_backgroundColor_minimal_active: baseTheme.color_gray_10,
    PrimaryNavItem_backgroundColor_minimal_focus: 'transparent',
    PrimaryNavItem_backgroundColor_minimal_hover: 'transparent',
    PrimaryNavItem_backgroundColor_minimal_selected: baseTheme.color_gray_10,
    PrimaryNavItem_borderColor: 'transparent',
    PrimaryNavItem_borderColor_active: 'transparent',
    PrimaryNavItem_borderColor_focus: baseTheme.color_theme_20,
    PrimaryNavItem_borderColor_hover: 'transparent',
    PrimaryNavItem_borderColor_selected: baseTheme.color_theme_80,
    PrimaryNavItem_borderColor_minimal: 'transparent',
    PrimaryNavItem_borderColor_minimal_active: 'transparent',
    PrimaryNavItem_borderColor_minimal_focus: baseTheme.color_theme_40,
    PrimaryNavItem_borderColor_minimal_hover: 'transparent',
    PrimaryNavItem_borderColor_minimal_selected: baseTheme.color_theme_40,
    PrimaryNavItem_color: baseTheme.color_themePrimary,
    PrimaryNavItem_color_disabled: baseTheme.color_theme_40,
    PrimaryNavItem_color_hover: baseTheme.color_themePrimary,
    PrimaryNavItem_color_selected: baseTheme.color_themePrimary,
    PrimaryNavItem_color_minimal: baseTheme.color_gray_80,
    PrimaryNavItem_color_minimal_hover: baseTheme.color_theme_60,
    PrimaryNavItem_color_minimal_selected: baseTheme.color_theme_70,
    PrimaryNavItem_paddingHorizontal: baseTheme.space_inset_sm,
    PrimaryNavItemIcon_color: 'inherit'
  };
};

exports.primaryNavItemTheme = primaryNavItemTheme;

var secondaryNavItemTheme = function secondaryNavItemTheme(baseTheme) {
  return {
    SecondaryNavItem_backgroundColor_pills: 'transparent',
    SecondaryNavItem_backgroundColor_pills_active: baseTheme.color_gray_10,
    SecondaryNavItem_backgroundColor_pills_focus: 'transparent',
    SecondaryNavItem_backgroundColor_pills_hover: 'transparent',
    SecondaryNavItem_backgroundColor_pills_selected: baseTheme.backgroundColor_themePrimary,
    SecondaryNavItem_backgroundColor_tabs: 'transparent',
    SecondaryNavItem_backgroundColor_tabs_active: baseTheme.color_gray_10,
    SecondaryNavItem_backgroundColor_tabs_focus: 'transparent',
    SecondaryNavItem_backgroundColor_tabs_hover: 'transparent',
    SecondaryNavItem_backgroundColor_tabs_selected: baseTheme.backgroundColor,
    SecondaryNavItem_borderColor_pills: 'transparent',
    SecondaryNavItem_borderColor_pills_active: 'transparent',
    SecondaryNavItem_borderColor_pills_focus: baseTheme.color_theme_40,
    SecondaryNavItem_borderColor_pills_hover: 'transparent',
    SecondaryNavItem_borderColor_pills_selected: baseTheme.backgroundColor_themePrimary,
    SecondaryNavItem_borderColor_tabs: 'transparent',
    SecondaryNavItem_borderColor_tabs_active: 'transparent',
    SecondaryNavItem_borderColor_tabs_focus: baseTheme.color_theme_40,
    SecondaryNavItem_borderColor_tabs_hover: 'transparent',
    SecondaryNavItem_borderColor_tabs_selected: baseTheme.color_theme_40,
    SecondaryNavItem_color_pills: baseTheme.color_gray_80,
    SecondaryNavItem_color_pills_hover: baseTheme.color_theme_60,
    SecondaryNavItem_color_pills_selected: baseTheme.color_themePrimary,
    SecondaryNavItem_color_tabs: baseTheme.color_gray_80,
    SecondaryNavItem_color_tabs_hover: baseTheme.color_theme_60,
    SecondaryNavItem_color_tabs_selected: baseTheme.color_theme_70,
    SecondaryNavItem_paddingHorizontal: baseTheme.space_inset_md,
    SecondaryNavItemIcon_color: 'inherit'
  };
};

exports.secondaryNavItemTheme = secondaryNavItemTheme;

var navItemTheme = function navItemTheme(baseTheme) {
  return _objectSpread({}, primaryNavItemTheme(baseTheme), secondaryNavItemTheme(baseTheme), baseTheme);
};

exports.navItemTheme = navItemTheme;